import theme from "@monorepo/styles/theme";
import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

interface IWrapperProps extends BoxProps {
  isMobile: boolean;
}

interface IContextMenuProps extends BoxProps {
  isMobile?: boolean;
}

interface IMainProps {
  secondaryBg: boolean;
  hasMobilePopUp?: boolean;
  isMobile?: boolean;
  hideMobileScrollbar?: boolean;
}

export const Wrapper = styled(Box, { shouldForwardProp: (prop) => prop !== "isMobile" })<IWrapperProps>(
  ({ isMobile }) => ({
    position: "relative",
    display: "grid",
    overflowX: "hidden",
    width: "100%",
    height: "100vh",
    ...(isMobile && {
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
      height: "100%",
    }),
    margin: 0,
    boxSizing: "border-box",
    gridTemplateRows: "75px 1fr",
    [theme.breakpoints.up("md")]: {
      gridTemplateRows: "max-content",
      gridTemplateColumns: "370px 1fr",
    },
    [theme.breakpoints.up("xl")]: {
      gridTemplateColumns: "470px 1fr",
    },
    [theme.breakpoints.up("xxl")]: {
      gridTemplateColumns: "470px minmax(320px, 1fr)",
    },
  })
);

export const ContextMenu = styled(Box, { shouldForwardProp: (prop) => prop !== "isMobile" })<IContextMenuProps>(
  ({ isMobile }) => ({
    display: "grid",
    alignItems: "flex-start",
    alignContent: "flex-start",
    padding: `${theme.spacing(0)} ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)}`,
    height: "100%",
    ...(isMobile && {
      height: "auto",
      marginTop: theme.spacing(5),
      width: "100%",
    }),
    backgroundColor: theme.palette.background.default,
    overflowY: "auto",
    gridTemplateRows: "auto auto",
    [theme.breakpoints.up("md")]: {
      gridTemplateRows: "max-content",
      height: "100vh",
      padding: "20px 15px 20px 15px",
    },
    [theme.breakpoints.up("xl")]: {
      padding: "20px 35px 20px 35px",
    },
    [theme.breakpoints.up("xxl")]: {
      padding: "20px 60px 20px 60px",
    },
  })
);

export const Main = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "secondaryBg" && prop !== "hasMobilePopUp" && prop !== "isMobile" && prop !== "hideMobileScrollbar",
})<IMainProps>(({ secondaryBg, hasMobilePopUp, isMobile, hideMobileScrollbar }) => ({
  display: "grid",
  alignContent: "flex-start",
  padding: `${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(4)} ${theme.spacing(1)}`,
  backgroundColor: secondaryBg ? theme.palette.background.paper : theme.palette.background.default,
  overflowY: "auto",
  position: "inherit",
  left: "inherit",
  top: "inherit",
  minHeight: "inherit",
  width: "100%",
  ...(isMobile && {
    flex: 1,
    height: "auto",
    width: "100%",
  }),
  zIndex: hasMobilePopUp ? 101 : "inherit",
  [theme.breakpoints.up("md")]: {
    alignContent: "flex-start",
    height: "100vh",
    padding: "0px 0px 0px 20px",
    position: "inherit",
    minHeight: "inherit",
    width: "inherit",
    zIndex: "inherit",
  },
  [theme.breakpoints.up("xl")]: {
    padding: "0px 0px 0px 40px",
  },
  [theme.breakpoints.up("xxl")]: {
    padding: "0px 0px 0px 80px",
  },
  msOverflowStyle: "none",
  scrollbarWidth: "none",
  WebkitOverflowScrolling: "touch",
  "&::-webkit-scrollbar": {
    display: hideMobileScrollbar ? "none" : "initial",
  },
}));
